export enum DialogThemeMode {
  dark = "dark",
  light = "light",
}

export enum Categories {
  masterclasses = "Masterclass Library",
  aiTools = "Suraasa AI Tools",
  webinars = "Webinars",
  jobs = "Jobs",
}

type PlanItem = {
  label: string
  free: string
  plus: string
}

type PlanCategory = {
  category: Categories
  items: PlanItem[]
}

enum Variant {
  mobile = "mobile",
  modal = "modal",
  default = "default",
}

function _resolveVariant(isMobile: boolean, modalVariant?: boolean): Variant {
  if (isMobile) return Variant.mobile
  if (modalVariant) return Variant.modal
  return Variant.default
}

// const PLAN_TEXTS = {
//   aiTools: {
//     generations: {
//       free: (limit?: number) => ({
//         [Variant.mobile]: limit
//           ? `${pluralize("generation", limit)} per day`
//           : "Limited Generations per day",
//         [Variant.modal]: limit ? `${limit} per day` : "Limited per day",
//         [Variant.default]: limit
//           ? `Limited to ${pluralize("use", limit)} per day`
//           : "Limited Generations per day",
//       }),
//       plus: {
//         [Variant.mobile]: "Unlimited Generations",
//         [Variant.modal]: "Unlimited",
//         [Variant.default]: "Unlimited access",
//       },
//     },
//   },
//   masterClasses: {
//     recorded: {
//       free: {
//         [Variant.mobile]: "1 Recorded Session per month",
//         [Variant.modal]: "1 per month",
//         [Variant.default]: "Limited to 1 view per month",
//       },
//       plus: {
//         [Variant.mobile]: "Watch Unlimited Recorded Sessions",
//         [Variant.modal]: "Unlimited",
//         [Variant.default]: "Unlimited access to full library",
//       },
//     },
//     live: {
//       free: "✕",
//       plus: {
//         [Variant.mobile]: "Attend All Live Sessions",
//         [Variant.modal]: "All",
//         [Variant.default]: "All Sessions",
//       },
//     },
//     certificate: {
//       label: {
//         [Variant.modal]: "Earn Certificate of Participation",
//         [Variant.default]: "Certificate with Live Sessions",
//       },
//       free: "✕",
//       plus: {
//         [Variant.mobile]: "Earn Certificate of Participation",
//         [Variant.default]: "Included",
//       },
//     },
//   },
//   webinars: {
//     recorded: {
//       free: {
//         [Variant.mobile]: "Unlimited Recorded Sessions",
//         [Variant.modal]: "Unlimited",
//         [Variant.default]: "Unlimited access",
//       },
//       plus: {
//         [Variant.mobile]: "Unlimited Recorded Sessions",
//         [Variant.modal]: "Unlimited",
//         [Variant.default]: "Unlimited access",
//       },
//     },
//     live: {
//       free: {
//         [Variant.mobile]: "Attend All Live Sessions",
//         [Variant.modal]: "All",
//         [Variant.default]: "All Sessions",
//       },
//       plus: {
//         [Variant.mobile]: "Attend All Live Sessions",
//         [Variant.modal]: "All",
//         [Variant.default]: "All Sessions",
//       },
//     },
//     certificate: {
//       label: {
//         [Variant.modal]: "Earn Certificate of Participation",
//         [Variant.default]: "Certificate with Live Sessions",
//       },
//       free: "✕",
//       plus: {
//         [Variant.mobile]: "Earn Certificate of Participation",
//         [Variant.default]: "Included",
//       },
//     },
//   },
//   jobs: {
//     invites: {
//       free: {
//         [Variant.mobile]: "Unlimited Job Invites",
//         [Variant.default]: "Unlimited",
//       },
//       plus: {
//         [Variant.mobile]: "Unlimited Job Invites",
//         [Variant.default]: "Unlimited",
//       },
//     },
//     apply: {
//       free: (limit?: number) => ({
//         [Variant.mobile]: limit
//           ? `Limited to ${pluralize("job application", limit)}`
//           : "Limited applications",
//         [Variant.default]: limit
//           ? `Limited to ${limit}`
//           : "Limited applications",
//       }),
//       plus: {
//         [Variant.mobile]: "Unlimited Job Applications",
//         [Variant.default]: "Unlimited",
//       },
//     },
//   },
// }
const PLAN_TEXTS = {
  aiTools: {
    generations: {
      free: "Access limited to once a day",
      plus: "Unlimited access",
    },
  },
  masterClasses: {
    recorded: {
      free: "1 Recorded Session per month",
      plus: "Unlimited access ",
    },
    live: {
      free: "Pay per class",
      plus: "Access to all live sessions",
    },
    certificate: {
      label: "Earn Certificate of Participation",
      free: "Certificate not included",
      plus: "Certificate included with every live session",
    },
  },
  webinars: {
    recorded: {
      free: {
        [Variant.mobile]: "Unlimited Recorded Sessions",
        [Variant.modal]: "Unlimited",
        [Variant.default]: "Unlimited access",
      },
      plus: {
        [Variant.mobile]: "Unlimited Recorded Sessions",
        [Variant.modal]: "Unlimited",
        [Variant.default]: "Unlimited access",
      },
    },
    live: {
      free: {
        [Variant.mobile]: "Attend All Live Sessions",
        [Variant.modal]: "All",
        [Variant.default]: "All Sessions",
      },
      plus: {
        [Variant.mobile]: "Attend All Live Sessions",
        [Variant.modal]: "All",
        [Variant.default]: "All Sessions",
      },
    },
    certificate: {
      label: {
        [Variant.modal]: "Earn Certificate of Participation",
        [Variant.default]: "Certificate with Live Sessions",
      },
      free: "✕",
      plus: {
        [Variant.mobile]: "Earn Certificate of Participation",
        [Variant.default]: "Included",
      },
    },
  },
  jobs: {
    invites: {
      free: "Unlimited job Invites",
      plus: "Unlimited job Invites",
    },
    apply: {
      free: "Only 2 job applications",
      plus: "Unlimited Job Applications",
    },
  },
  skillAssessment: {
    cpat: {
      free: "CPAT not included",
      plus: "CPAT included",
    },
    report: {
      free: "Pedagogical Diagnostic Report not included",
      plus: "Pedagogical Diagnostic Report included",
    },
  },
  impactCourse: {
    course: {
      free: "Not included",
      plus: "Included",
    },
  },
}

// function pick(obj: Partial<Record<Variant, string>>, variant: Variant): string {
//   return obj[variant] ?? obj[Variant.default] ?? ""
// }

export function getSuraasaPlusPlans(_props: {
  isMobile: boolean
  modalVariant?: boolean
  aiToolsFreeLimit?: number
  jobsFreeLimit?: number
}): PlanCategory[] {
  return [
    {
      category: Categories.aiTools,
      items: [
        {
          label: "Generations",
          free: PLAN_TEXTS.aiTools.generations.free,
          plus: PLAN_TEXTS.aiTools.generations.plus,
        },
      ],
    },
    {
      category: Categories.masterclasses,
      items: [
        {
          label: "View Recorded Sessions",
          free: PLAN_TEXTS.masterClasses.recorded.free,
          plus: PLAN_TEXTS.masterClasses.recorded.plus,
        },
        {
          label: "Attend Live Sessions",
          free: PLAN_TEXTS.masterClasses.live.free,
          plus: PLAN_TEXTS.masterClasses.live.plus,
        },
        {
          label: PLAN_TEXTS.masterClasses.certificate.label,
          free: PLAN_TEXTS.masterClasses.certificate.free,
          plus: PLAN_TEXTS.masterClasses.certificate.plus,
        },
      ],
    },
    // {
    //   category: Categories.webinars,
    //   items: [
    //     {
    //       label: "View Recorded Sessions",
    //       free: PLAN_TEXTS.webinars.recorded.free,
    //       plus: PLAN_TEXTS.webinars.recorded.plus,
    //     },
    //     {
    //       label: "Attend Live Sessions",
    //       free: PLAN_TEXTS.webinars.live.free,
    //       plus: PLAN_TEXTS.webinars.live.plus,
    //     },
    //     {
    //       label:
    //         PLAN_TEXTS.webinars.certificate.label[variant] ??
    //         PLAN_TEXTS.webinars.certificate.label[Variant.default],
    //       free: PLAN_TEXTS.webinars.certificate.free,
    //       plus: PLAN_TEXTS.webinars.certificate.plus,
    //     },
    //   ],
    // },
    {
      category: Categories.jobs,
      items: [
        {
          label: "Job Invites",
          free: PLAN_TEXTS.jobs.invites.free,
          plus: PLAN_TEXTS.jobs.invites.plus,
        },
        {
          label: "Apply to Jobs",
          free: PLAN_TEXTS.jobs.apply.free,
          plus: PLAN_TEXTS.jobs.apply.plus,
        },
      ],
    },
  ]
}
